require('./bootstrap');

document.addEventListener('DOMContentLoaded', function(event) {

    // Resize video on load
    resizeVideo();

    // Resize the video on page resize
    window.onresize = resizeVideo;

});

function resizeVideo() {
    const video_container = document.getElementById('video-container');
    const video_player = document.getElementById('video-player');
    let window_width = window.innerWidth;
    let window_height = window.innerHeight;
    var video_src;

    // Switch video src based on orientation of the browser
    if( window_width > window_height || window_width >= 768 ) {
        video_container.classList.remove("portrait");
        video_container.classList.add("landscape");
        video_src = video_player.getAttribute('data-video-landscape');
        video_player.setAttribute('src', video_src);
    }else{
        video_container.classList.remove("landscape");
        video_container.classList.add("portrait");
        video_src = video_player.getAttribute('data-video-portrait');
        video_player.setAttribute('src', video_src);
    }
}